import React from 'react';
interface PhoneMockupProps {
  imageUrl: string;
  alt: string;
}
export function PhoneMockup({
  imageUrl,
  alt
}: PhoneMockupProps) {
  return <div className="relative w-full max-w-[340px] mx-auto" data-id="element-103">
      {/* Phone frame */}
      <div className="relative bg-gray-900 rounded-[3rem] p-3 shadow-2xl" data-id="element-104">
        {/* Notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-40 h-7 bg-gray-900 rounded-b-3xl z-10" data-id="element-105"></div>

        {/* Screen */}
        <div className="relative bg-white rounded-[2.5rem] overflow-hidden" data-id="element-106">
          <img src={imageUrl} alt={alt} className="w-full h-auto" data-id="element-107" />
        </div>
      </div>
    </div>;
}